import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-clock-out-modal',
    templateUrl: './clock-out-modal.component.html',
    styleUrls: ['./clock-out-modal.component.css'],
    standalone: false
})
export class ClockOutModalComponent implements OnInit {
  @Input() woData: any;
  @Input() clockStatus: any;
  @Input() isTripExist: boolean;
  clockEmpty: any;
  clockOut: boolean;
  alert: string | null;

  constructor(private ngbActiveModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.clockEmpty = false;

    if (this.clockStatus == null) this.clockEmpty = true;

    if (this.clockStatus != null) {
      if (!this.isTripExist && !this.clockEmpty && this.clockStatus.ClockAction) {
        if (this.clockStatus.SMTripID != null)
          this.alert =
            'The work order you are clocking out of must be present in your dashboard filter.  Modify your date filter to include this work order.';
        else this.alert = 'You are not currently clocked into a SM Work Order.';
      }
    }
  }

  clockOutClicked() {
    this.ngbActiveModal.close();
  }

  cancelClicked() {
    this.ngbActiveModal.dismiss();
  }
}
